import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useField } from 'react-final-form';
export function RenderByObservedFieldValue(_a) {
    var observedFieldName = _a.observedFieldName, isInverse = _a.isInverse, children = _a.children, checkRender = _a.checkRender;
    var value = useField(observedFieldName, { subscription: { value: true } }).input.value;
    if ((checkRender && !checkRender(value)) || (isInverse ? value : !value))
        return null;
    return _jsx(_Fragment, { children: children });
}
